const DocumentStatuses = Object.freeze({
  OPEN: 1,
  IN_PROGRESS: 2,
  DONE: 3,
});

export default DocumentStatuses;
